var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 96 960 960",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M776 822q27.917 0 47.458-19.559Q843 782.882 843 754.941T823.458 708Q803.917 689 776 689q-27.5 0-46.75 19.353t-19.25 47Q710 783 729.25 802.5T776 822Zm-.214 133Q809 955 838 939.5t47-42.5q-25-14-52.329-22.5T776 866q-28 0-55.5 8.5T667 897q18 27 46.786 42.5 28.785 15.5 62 15.5ZM367 394h215v-71q0-50-31.015-81-31.014-31-76.75-31-45.318 0-76.277 31Q367 273 367 323v71Zm219 605H224q-38.462 0-66.731-27.975Q129 943.05 129 905V489q0-38.463 28.269-66.731Q185.538 394 224 394h49v-71q0-90.34 57.76-148.67 57.759-58.33 143-58.33 85.24 0 143.74 59Q676 234 676 323v71h49q38.463 0 66.731 28.269Q820 450.537 820 489v93q-20-4-45-3.5t-50 4.5v-94H224v416h314q6 24 18 48.5t30 45.5Zm190 26q-79 0-136-57t-57-136q0-79 57-136t136-57q79 0 136 57t57 136q0 79-57 136t-136 57ZM224 489v416-416Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockPerson);
export default __webpack_public_path__ + "static/media/lock_person.e8b100c94029b34b10f608247fb072a9.svg";
export { ForwardRef as ReactComponent };